import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { from, Observable, switchMap } from 'rxjs';
import { fetchAuthSession } from 'aws-amplify/auth';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.getToken().pipe(
      switchMap((token) => {
        return next.handle(request.clone(
          {
            setHeaders: { Authorization: `Bearer ${token}` }
          })
        );
      })
    );
  }

  private getToken() {
    return from(
      new Promise((resolve, reject) => {
        fetchAuthSession().then((session) => {
          if (!session.tokens.idToken) {
            resolve(null);
          } else {
            resolve(session.tokens.idToken.toString());
          }
        })
        .catch(err=>{ return resolve(null) });
      })
    );
  }
}

